import { render } from "./ModalNewAzienda.vue?vue&type=template&id=1ee60427&scoped=true"
import script from "./ModalNewAzienda.vue?vue&type=script&lang=js"
export * from "./ModalNewAzienda.vue?vue&type=script&lang=js"

import "./ModalNewAzienda.vue?vue&type=style&index=0&id=1ee60427&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee60427"]])

export default __exports__